import { FC, ReactNode } from "react";
import { useTranslation } from "react-i18next";

import { BasicKeyValuePair } from "@components/for_drawer/BasicKeyValuePair";
import { BasicTwoLines } from "@components/for_drawer/BasicTwoLines";
import { BasicTwoParagraphs } from "@components/for_drawer/BasicTwoParagraphs";

import { ResourceMetadata, ResourceSummaryModel } from "@resource/models";

import { formatterShort } from "@utils/time-utils";

import { SerialNumberKeyValuePair } from "./SerialNumberKeyValuePair";

interface Props {
  data: ResourceSummaryModel;
}

export const SectionMetadata: FC<Props> = ({ data }) => {
  const content: ReactNode[] = [];
  const { t } = useTranslation(undefined, {
    keyPrefix: "resource"
  });

  content.push(
    <SerialNumberKeyValuePair
      key={`key-${data.id}-serial-number`}
      baseKey={t("drawer.labels.serialNumber")}
      baseValue={data.serialNumber}
    />,
    <BasicKeyValuePair
      key={`key-${data.id}-resource-type`}
      baseKey={t("drawer.labels.resourceType")}
      baseValue={data.resourceType}
    />,
    <BasicKeyValuePair
      key={`key-${data.id}-registered-at`}
      baseKey={t("drawer.labels.registered-at")}
      baseValue={formatterShort(data.createdOn)}
    />,
    <BasicTwoLines key={`key-${data.id}-just-lines`} />
  );

  if (data?.metadata?.length) {
    const metadata = data?.metadata;
    let sortedMetadata: ResourceMetadata[] = [];

    sortedMetadata = [...metadata].sort((a, b) => a.key.localeCompare(b.key));

    if (sortedMetadata?.length) {
      for (const { key, value } of sortedMetadata) {
        content.push(
          <BasicKeyValuePair
            key={`key-${key}`} // is expected, that metadata key will be ALWAYS different from Resources database
            baseKey={key}
            baseValue={value}
          />
        );
      }
    }
  }

  return content?.length > 0 ? (
    content
  ) : (
    <BasicTwoParagraphs text={"No metadata info"} />
  );
};
